export enum AddressPageType {
  GeographicalLevels = 'geographicalLevels',
  SearchedAddress = 'searchedAddress',
  Legacy = 'legacy',
  SimplePage = 'simplepage'
}
